const EnumOperationSystem = {
    None: 0,
    Other: 1,
    Windows: 2,
    Linux: 3,
    macOS: 4,
    Android: 5,
    iOs: 6
};

export default EnumOperationSystem
